export default __webpack_public_path__ + "static/media/menu.3cdc2212.svg";